import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import modalActions from 'actions/FullScreenModal';
import appContactActions from 'actions/Contact';
import DeleteContact from 'components/ContactModal/DeleteContact';
import { contactActions } from '@lifesize/nucleus';
import _get from 'lodash/get';

function mapDispatchToProps(dispatch) {
  return {
    deleteContact: (contactObj) => {
      dispatch(appContactActions.setDeletingState(true));
      dispatch(contactActions.deleteContact(contactObj)).then(() => {
        dispatch(appContactActions.setDeletingState(false));
        dispatch(modalActions.closeFullScreenModal());
      })
        .catch((err) => {
          dispatch(appContactActions.setDeletingError(err));
          dispatch(modalActions.closeFullScreenModal());
        });
    },
    handleCancel: () => {
      dispatch(modalActions.closeFullScreenModal());
    }
  };
}
const mapStateToProps = state => ({
  contact: _get(state, 'app.contactModal.contactObj'),
  deleting: _get(state, 'app.contacts.deletingContact'),
  deleteError: _get(state, 'app.contacts.deletingError')
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DeleteContact));
